"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShoppingCart, TestTube, Microscope, ArrowRight } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const steps = [{
  phase: "01",
  title: "Select Your Model",
  description: "Browse 100+ ready-to-brand watch models and pick the style that fits your vision",
  icon: ShoppingCart
}, {
  phase: "02",
  title: "Customize Branding",
  description: "Send us your logo — we'll engrave it, print it, or stamp it, whatever works best for your brand",
  icon: TestTube
}, {
  phase: "03",
  title: "Quality Control",
  description: " testingEvery watch is QC-checked before it ships. You get what you approved, every time",
  icon: Microscope
}];
export default function HowDnaTestingWorks() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="38018" id="simple-process" ref={ref} className="relative w-full bg-background py-[120px] overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl opacity-10 bg-[radial-gradient(circle_at_center,var(--border)_0%,transparent_70%)]" />
      </div>

      <div className="container mx-auto px-4 relative z-10">
        {}
        <div className={`text-center max-w-3xl mx-auto mb-20 transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <h2 className="text-3xl md:text-4xl font-sans font-bold text-foreground mb-6 tracking-tight">
            How It Works (Simple & Fast)
          </h2>
          <p className="text-lg text-secondary font-sans">
            Our organized industrial approach ensures your custom orders are handled with precision 
            from initial selection to final delivery.
          </p>
        </div>

        {}
        <div className="relative">
          {}
          <div className="hidden lg:block absolute top-[88px] left-0 w-full h-px border-t-2 border-dashed border-border -z-10" />

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {steps.map((step, i) => {
            const Icon = step.icon;
            const delay = i * 150;
            return <div key={i} data-index={i} className={`group relative flex flex-col transition-all duration-700 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
              transitionDelay: `${delay}ms`
            }}>
                  <Card className="h-full bg-card border border-border rounded-lg shadow-none hover:border-primary/30 transition-all duration-200 ease-[cubic-bezier(0.25,0.46,0.45,0.94)] overflow-hidden">
                    <CardContent className="p-8 flex flex-col items-center text-center h-full">
                      {}
                      <span className="font-sans text-5xl font-bold tracking-tighter text-border mb-6 bg-transparent px-0 py-0 rounded-none">
                        {step.phase}
                      </span>

                      {}
                      <div className="relative mb-6">
                        <div className="absolute inset-0 bg-primary/5 blur-xl opacity-0 group-hover:opacity-100 rounded-full transition-opacity" />
                        <div className="relative bg-background border border-border p-4 rounded-full text-foreground group-hover:border-primary/50 transition-colors duration-300">
                          <Icon className="w-8 h-8" strokeWidth={1.5} />
                        </div>
                      </div>

                      {}
                      <h3 className="text-xl font-sans font-bold text-foreground mb-3">
                        {step.title}
                      </h3>
                      <p className="text-secondary font-sans text-sm leading-relaxed">
                        {step.description}
                      </p>
                    </CardContent>
                  </Card>
                </div>;
          })}
          </div>
        </div>

        {}
        <div className={`mt-16 text-center transition-all duration-700 delay-500 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}>
          <Button asChild size="lg" className="bg-primary hover:bg-primary/90 text-primary-foreground rounded-md px-8 py-6 text-lg shadow-none transition-all">
            <Link to="/CollectionPage">
              Start Your Project
              <ArrowRight className="ml-2 w-5 h-5" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}